module.exports = __webpack_public_path__ + "img/2.7611824e.jpg";